import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';

@Injectable({ providedIn: 'root' })
export class UserService {
  private _user: KeycloakProfile;
  public licenses: any[];

  constructor(private readonly keycloak: KeycloakService) {}

  loaduser() {
    return this.keycloak.loadUserProfile().then(
      (user: KeycloakProfile) => {
        this._user = user;
        // Map all properties of _user.attributes to a plain result. The default attributes comes in an array.
        Object.keys(this._user.attributes).forEach((key: string) => {
          const value = this._user.attributes[key][0];
          try {
            // Try to parse the object
            this._user.attributes[key] = JSON.parse(value);
          } catch {
            // If it's not possible to parse it means is an string
            this._user.attributes[key] = value;
          }
        });
        return true;
      },
      () => false
    );
  }

  getUser(): KeycloakProfile {
    return this._user;
  }

  logout() {
    localStorage.clear();
    this.keycloak.logout(window.location.origin);
  }

  isTeacher(): boolean {
    if (!this._user) return false;
    return (
      (this._user.attributes['roles'] as string[]).includes('TEACHER') || (this._user.attributes['roles'] as string[]).includes('ADMIN')
    );
  }
}
